import React from 'react'
import styled from 'styled-components'

import constants from 'utils/constants'

export default function UserCategoryScene({ categories, selectedCategory, onToggle }) {
  return (
    <SceneSection>
      <SectionHeader>
        <HeaderTitleWrapper>
          <HeaderTitle>관심사를 선택해 주세요</HeaderTitle>
          <HeaderTitleNote>(최대 2개)</HeaderTitleNote>
        </HeaderTitleWrapper>
        <HeaderDescription>관심사에 맞는 상품 챌린지를 추천해 드려요!</HeaderDescription>
      </SectionHeader>
      <SectionBody>
        {categories &&
          Array.isArray(categories) &&
          categories.map((category, index) => {
            if (
              selectedCategory.filter(
                (selected) => parseInt(selected['no']) === parseInt(category['no']),
              ).length > 0
            ) {
              return (
                <SelectedItem
                  key={`category-item-no-${category['no']}`}
                  onClick={() => {
                    if (onToggle) onToggle(category['no'])
                  }}
                >
                  <ItemTop>
                    <ItemIcon
                      src={`${constants.imagePath}/category/icon/${category['category_icon']}`}
                    />
                  </ItemTop>
                  <ItemBottom>{category['name']['ko']}</ItemBottom>
                </SelectedItem>
              )
            } else {
              return (
                <CategoryItem
                  key={`category-item-no-${category['no']}`}
                  onClick={() => {
                    if (onToggle) onToggle(category['no'])
                  }}
                >
                  <ItemTop>
                    <ItemIcon
                      src={`${constants.imagePath}/category/icon/${category['category_icon']}`}
                    />
                  </ItemTop>
                  <ItemBottom>{category['name']['ko']}</ItemBottom>
                </CategoryItem>
              )
            }
          })}
      </SectionBody>
    </SceneSection>
  )
}

export const SceneSection = styled.div`
  height: 100%;
  padding: 0 calc(100vw * (17 / 375));
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow-y: scroll;
`
export const SectionHeader = styled.div`
  margin-top: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (53 / 375));
`

export const HeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (4 / 375));
`
export const HeaderTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: calc(100vw * (23 / 375));
  line-height: calc(100vw * (36 / 375));
  color: #121212;
`
export const HeaderTitleNote = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (21 / 375));
  color: #7f7f7f;
`

export const HeaderDescription = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #7f7f7f;
`
export const SectionBody = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: calc(100vw * (12 / 375));
`

export const CategoryItem = styled.div`
  background: #f7f7f7;
  border-radius: calc(100vw * (16 / 375));
  width: calc(100vw * (103 / 375));
  height: calc(100vw * (103 / 375));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  margin-bottom: calc(100vw * (14 / 375));
  box-sizing: border-box;
`
export const SelectedItem = styled(CategoryItem)`
  background: #fff4d8;
  border: 1.5px solid #ffcf19;
`
export const ItemTop = styled.div`
  width: calc(100vw * (66 / 375));
  height: calc(100vw * (66 / 375));
`

export const ItemIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
export const ItemBottom = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  color: #4e4e4e;
`
